"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faArrowCircleLeft = require("@fortawesome/pro-regular-svg-icons/faArrowCircleLeft");

var _faSpinner = require("@fortawesome/pro-regular-svg-icons/faSpinner");

var _faEye = require("@fortawesome/pro-regular-svg-icons/faEye");

var _reactHelmet = require("react-helmet");

var _peractoUi = require("@peracto/peracto-ui");

var _client = require("@peracto/client");

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _RedirectsImportStatusList = _interopRequireDefault(require("./RedirectsImportStatusList"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ImportSummaryPod = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 10px;\n    border: 1px solid #ddd;\n    width: 100%;\n    border-radius: 3px;\n    font-size: 16px;\n"])));

var ImportSummary = function ImportSummary(_ref) {
  var summaryTitle = _ref.summaryTitle,
      total = _ref.total,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react["default"].createElement(ImportSummaryPod, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-weight-bold"
  }, summaryTitle), /*#__PURE__*/_react["default"].createElement("span", null, total));
};

var RedirectImportStatus = function RedirectImportStatus() {
  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      importSummaryData = _useState2[0],
      setImportSummaryData = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      importLinesData = _useState4[0],
      setImportLinesData = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      redirect = _useState8[0],
      setRedirect = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      countdown = _useState10[0],
      setCountdown = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      countdownTimer = _useState12[0],
      setCountdownTimer = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showAll = _useState14[0],
      setShowAll = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      importFailed = _useState16[0],
      setImportFailed = _useState16[1];

  var _useState17 = (0, _react.useState)(),
      _useState18 = _slicedToArray(_useState17, 2),
      timeAtPageLoad = _useState18[0],
      setTimeAtPageLoad = _useState18[1];

  var pageTitle = !loading ? "Redirects Import" : 'Loading...';

  var _useParams = (0, _reactRouterDom.useParams)(),
      id = _useParams.id;

  var filter = showAll ? {
    "import": id,
    successful: true
  } : {
    "import": id,
    successful: false
  };

  var fetchImportStatus = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$client, importSummary, importSummaryReponse, _yield$client2, importLines, longRunning, timer;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return client(_client.GET_ONE, 'imports', {
                id: "/imports/".concat(id)
              });

            case 3:
              _yield$client = _context.sent;
              importSummary = _yield$client.data;
              importSummaryReponse = _yield$client.response;
              _context.next = 8;
              return client(_client.GET_LIST, "import-lines", {
                id: "/import-lines",
                filter: filter
              });

            case 8:
              _yield$client2 = _context.sent;
              importLines = _yield$client2.data;
              setImportSummaryData(importSummary);
              setImportLinesData(importLines);
              setLoading(false);
              longRunning = new Date().getTime() - timeAtPageLoad > 90000;
              timer = (importSummary === null || importSummary === void 0 ? void 0 : importSummary.processedCount) > 0 ? longRunning ? 20000 : 10000 : 5000;
              setCountdown(new Date().getTime() + timer);

              if (importSummaryReponse.status === 404) {
                setRedirect('/redirects/import');
              }

              _context.next = 24;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              setLoading(false);
              setRedirect('/redirects/import');

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 19]]);
    }));

    return function fetchImportStatus() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    var longRunning = new Date().getTime() - timeAtPageLoad > 90000;
    var timer = (importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.processedCount) > 0 ? longRunning ? 20000 : 10000 : 5000;
    var hourDifference = (new Date().getTime() - new Date(importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.createdAt).getTime()) / 1000;
    hourDifference /= 60 * 60;
    var unknownImportFailure = hourDifference >= 2 && Math.round((importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.processedCount) / (importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.totalCount) * 100) < 100;
    setImportFailed(unknownImportFailure);
    var interval = setInterval(function () {
      if ((importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.totalCount) !== (importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.processedCount) && !unknownImportFailure) {
        fetchImportStatus();
      } else {
        clearInterval(interval);
      }
    }, timer);
    return function () {
      return clearInterval(interval);
    };
  }, [importSummaryData]);
  (0, _react.useEffect)(function () {
    fetchImportStatus();
    var d = new Date();
    setTimeAtPageLoad(d.getTime());
  }, []);
  (0, _react.useEffect)(function () {
    fetchImportStatus();
  }, [showAll]);
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      if ((importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.totalCount) === (importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.processedCount)) {
        setCountdownTimer(null);
        clearInterval(interval);
      } else {
        var time = new Date().getTime();
        setCountdownTimer(countdown - time);
      }
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [importSummaryData, countdown]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, redirect && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: redirect
  }), /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("title", null, pageTitle, " | Peracto")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-container"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Heading, {
    name: pageTitle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-center ml-2"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "btn btn-outline-primary",
    to: "/redirects/import"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faArrowCircleLeft.faArrowCircleLeft,
    className: "mr-2"
  }), "Back to Redirect Imports"))), /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "import-summary",
    id: "import-summary",
    name: "Summary"
  }, !loading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, importFailed ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-danger"
  }, "This import failed to complete. Please try again.")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, countdownTimer && Math.round(importSummaryData.processedCount / importSummaryData.totalCount * 100) < 100 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-end align-items-center my-1"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faSpinner.faSpinner,
    spin: true,
    className: "mr-2"
  }), /*#__PURE__*/_react["default"].createElement("span", null, (importSummaryData === null || importSummaryData === void 0 ? void 0 : importSummaryData.processedCount) === 0 && 'Adding import to queue - ', "Next update in", ' ', Math.ceil(countdownTimer / 1000), " seconds")), /*#__PURE__*/_react["default"].createElement(_peractoUi.ProgressBar, {
    total: importSummaryData.totalCount,
    current: importSummaryData.processedCount
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-6 col-lg-3"
  }, /*#__PURE__*/_react["default"].createElement(ImportSummary, {
    summaryTitle: "Total to Process",
    total: importSummaryData.totalCount
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-6 col-lg-3"
  }, /*#__PURE__*/_react["default"].createElement(ImportSummary, {
    summaryTitle: "Processed",
    total: importSummaryData.processedCount
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-6 col-lg-3"
  }, /*#__PURE__*/_react["default"].createElement(ImportSummary, {
    summaryTitle: "Successfully Imported",
    total: importSummaryData.successfulCount
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-6 col-lg-3"
  }, /*#__PURE__*/_react["default"].createElement(ImportSummary, {
    summaryTitle: "Import Errors",
    total: importSummaryData.errorCount,
    className: (0, _classnames["default"])({
      'text-danger': importSummaryData.errorCount > 0
    })
  })))) : 'Loading data...'), /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "import-lines",
    id: "import-lines",
    name: "Import Lines"
  }, !loading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-end my-2"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-link",
    onClick: function onClick() {
      return setShowAll(!showAll);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faEye.faEye,
    className: "mr-2"
  }), showAll ? 'Show Import Line Errors' : 'Show Successful Import Lines')), (importLinesData === null || importLinesData === void 0 ? void 0 : importLinesData.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_RedirectsImportStatusList["default"], {
    data: importLinesData,
    filter: filter,
    showAll: showAll
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex flex-column justify-content-center align-items-center my-4"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-center mb-0"
  }, "No Import ", showAll ? 'Lines' : 'Line Errors'))) : 'Loading data...')));
};

var _default = RedirectImportStatus;
exports["default"] = _default;